var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "button",
    {
      staticClass: "cw-manager-filing",
      class: {
        "cw-manager-filing-active": _vm.active,
        "cw-manager-filing-disabled": _vm.disabled
      },
      attrs: {
        "aria-pressed": _vm.active
      },
      on: {
        click: _vm.toggleFiling
      }
    },
    [
      _vm.itemType === "element"
        ? _c(
            "span",
            [_c("translate", [_vm._v("Seite an dieser Stelle einfügen")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.itemType === "container"
        ? _c(
            "span",
            [_c("translate", [_vm._v("Abschnitt an dieser Stelle einfügen")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.itemType === "block"
        ? _c(
            "span",
            [_c("translate", [_vm._v("Block an dieser Stelle einfügen")])],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }